<template>
  <div class="pd-select" v-show="pickerShow">
    <div class="layer">
      <div class="pd-select-head">
        <h2>{{ pickTitle }}</h2>
        <a href="javascript:void(0);" v-on:click="onClose" class="close">取消</a>
        <a href="javascript:void(0);" v-on:click="onSure" class="sure">确定</a>
      </div>
      <div class="pd-select-body">
        <picker ref="pdPicker" :slots="prodData" value-key="name" @change="onProductPick"></picker>
      </div>
    </div>
  </div>
</template>

<script>
import { Picker } from "mint-ui";
export default {
  name: "PdSelectBox",
  components: {
    Picker
  },
  data: () => ({
    product: {},
    prod_pkg: {},
    prodData: [],
    selectedItem: null,
    pickTitle: "选择套餐",
    pickerShow: false
  }),
  props: ["customMobile"],
  created() {
    this.loadProducts();
  },
  methods: {
    preparePkgData(rs) {
      let temp = [];
      for (var i = 0; i < rs.data.length; i++) {
        var item = rs.data[i];
        item.packages.forEach(function(sub) {
          sub["value"] = sub["package_code"];
          sub["name"] = sub["package_name"];
          sub["product"] = item;
          temp.push(sub);
        }, this);
      }
      this.prodData = [{ flex: 1, values: temp, className: "slot1" }];
      this.selectedItem = temp[0];
      this.onProductPick(0, temp)
    },
    onProductPick(picker, value) {
      console.log("pick: ", value);
      this.prod_pkg = value[0];
      console.log("prod_pkg: ", this.prod_pkg);
      this.product = this.prod_pkg.product;
      console.log("ProductPick: ", this.product, this.prod_pkg);
    },
    doShowPicker(flag) {
      this.pickerShow = flag;
    },
    onClose() {
      this.pickerShow = false;
    },
    onSure() {
      if (!this.product || !this.product.product_id) {
        this.toast("请选择套餐");
        return;
      }
      if (!this.prod_pkg || !this.prod_pkg.package_code) {
        this.toast("请选择套餐");
        return;
      }
      this.pickerShow = false;
      this.$store.dispatch("setSelectedPkg", { selectedPkg: this.prod_pkg });
      this.$emit("change", [this.product, this.prod_pkg]);
    },
    showPicker() {
      if (this.prodData.length === 0) {
        this.toast("该用户目前无可购买的套餐");
      } else {
        if (this.prodData[0].values.length === 0) {
          this.toast("该用户目前无可购买的套餐");
          return;
        }
        let setSlotValue = this.$refs.pdPicker.setSlotValue;
        setSlotValue(0, this.selectedItem);
        this.doShowPicker(true);
      }
    },
    loadProducts() {
      let self = this;
      // this.loading('正在读取数据')
      this.$http
        .get("/api/integration/products?mobile=" + this.customMobile, {})
        .then(
          response => {
            this.loadingHide();
            var rs = response.body;
            console.log("loadProducts: ", rs);
            if (rs.code === 0) {
              self.preparePkgData(rs);
            } else {
              if (rs.code === 4001) {
                this.$store.dispatch('clearNewOrder', {})
                this.$router.replace({'name': 'OrderNew'})
                this.toast("公司内部人员手机号不允许当成客户下单")
              } else {
                this.handleHttpError(response);
              }
            }
          },
          response => {
            // error callback
            console.log(response);
            this.handleHttpError(response);
          }
        );
    }
  }
};
</script>

<style scoped="">
.pd-select {
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/components/PdSelectBox.vue